import { Chain } from '@ankr.com/chains-list';

import { StatisticsWidget } from 'modules/chains/components/StatisticsWidget';

import { AAPIBenefits } from '../AAPIBenefits';
import { AAPIEndpointsWidget } from '../AAPIEndpointsWidget';
import { AAPIInfoTabs } from '../AAPIInfoTabs';

interface PublicAAPIPageContentProps {
  chain: Chain;
}

export const PublicAAPIPageContent = ({
  chain,
}: PublicAAPIPageContentProps) => {
  return (
    <>
      <AAPIEndpointsWidget chain={chain} />
      <AAPIInfoTabs />
      <AAPIBenefits />
      <StatisticsWidget chain={chain} />
    </>
  );
};
